import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Oorto delivery widget — keeps variant stock in sync; pincode form is a placeholder.
 *
 * @extends {Component}
 */
class OortoProductDelivery extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#setupPincodeForm();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #setupPincodeForm() {
    const form = this.querySelector('.oorto-delivery__pincode');
    const input = /** @type {HTMLInputElement | null} */ (this.querySelector('.oorto-delivery__input'));
    const button = this.querySelector('.oorto-delivery__change');
    const checkLabel = this.dataset.labelCheck ?? 'Check';
    const changeLabel = this.dataset.labelChange ?? 'Change';

    const updateButton = () => {
      if (!button || !input) return;
      button.textContent = input.value.trim() ? changeLabel : checkLabel;
    };

    input?.addEventListener('input', updateButton);
    form?.addEventListener('submit', (event) => event.preventDefault());
    updateButton();
  }

  /**
   * @param {ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newStock = html.querySelector('oorto-product-delivery [data-delivery-stock]');
        const currentStock = this.querySelector('[data-delivery-stock]');
        if (!newStock || !currentStock) return;

        morph(currentStock, newStock);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[oorto-product-delivery] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('oorto-product-delivery')) {
  customElements.define('oorto-product-delivery', OortoProductDelivery);
}
